import React, { memo } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const PagesMeta = memo(({ pageName, pageDescription }) => {
	const { t } = useTranslation();

	return (
		<Helmet>
			<title>
				{t("app title")} | {pageName}
			</title>
			<meta name='description' content={pageDescription} />
		</Helmet>
	);
});

PagesMeta.propTypes = {
	pageName: PropTypes.string.isRequired,
	pageDescription: PropTypes.string.isRequired,
};

export default PagesMeta;
